export enum NotificationTypes {
  supplierMatch = 'SUPPLIER_MATCH',
  matchesFound = 'MATCHES_FOUND',
  noMatchesFound = 'NO_MATCHES_FOUND',
  customerMatch = 'CUSTOMER_MATCH',
  newRequest = 'NEW_REQUEST',
}
